import VueScrollTo from "vue-scrollto";

export const scrollToHasError = () => {
    let container = document.body;
    let modal = [...document.querySelectorAll(".ant-modal-wrap")].filter((d) => !d.querySelector(".ant-modal-confirm"));
    if (modal.length > 0) {
        container = modal[modal.length - 1];
    }
    VueScrollTo.scrollTo(container.querySelector(".has-error"), { container, offset: -250 });
};

export const scrollWindowParentTo = (e) => {
    let document = window.parent.document;
    let container = document.body;
    let modal = document.querySelectorAll(".ant-modal-wrap");
    if (modal.length > 0) {
        container = modal[modal.length - 1];
    }
    VueScrollTo.scrollTo(e, { container, offset: 0 });
};

export const scrollToQuerySelector = (querySelector) => {
    if (querySelector) {
        let container = document.body;
        VueScrollTo.scrollTo(container.querySelector(querySelector), { container, offset: -200 });
    }
};
